import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./components/msalAuth/msalConfig";

export const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

const root = createRoot(document.getElementById("root"));
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
